import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { networkService } from "./network.service";

const networkKeys = {
  routes: ["network-routes"] as const,
  myRoutes: ["network-routes-mine"] as const,
  referrals: ["network-referrals"] as const,
  myReferrals: ["network-referrals-mine"] as const,
};

export const useOpenRoutes = () =>
  useQuery({ queryKey: networkKeys.routes, queryFn: networkService.getOpenRoutes });

export const useMyRoutes = () =>
  useQuery({ queryKey: networkKeys.myRoutes, queryFn: networkService.getMyRoutes });

export const useCreateRoute = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: networkService.createRoute,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: networkKeys.myRoutes });
      qc.invalidateQueries({ queryKey: networkKeys.routes });
    },
  });
};

export const useBookRoute = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, ...body }: { routeId: string; cubesRequested: number; notes?: string }) =>
      networkService.bookRoute(routeId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: networkKeys.routes }),
  });
};

export const useUpdateBooking = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, bookingId, status }: { routeId: string; bookingId: string; status: string }) =>
      networkService.updateBooking(routeId, bookingId, { status }),
    onSuccess: () => qc.invalidateQueries({ queryKey: networkKeys.myRoutes }),
  });
};

export const useOpenReferrals = () =>
  useQuery({ queryKey: networkKeys.referrals, queryFn: networkService.getOpenReferrals });

export const useMyReferrals = () =>
  useQuery({ queryKey: networkKeys.myReferrals, queryFn: networkService.getMyReferrals });

export const useCreateReferral = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: networkService.createReferral,
    onSuccess: () => qc.invalidateQueries({ queryKey: networkKeys.myReferrals }),
  });
};

export const useClaimReferral = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: networkService.claimReferral,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: networkKeys.referrals });
      qc.invalidateQueries({ queryKey: networkKeys.myReferrals });
    },
  });
};
